import * as React from 'react';
import { Embed } from '@core-ds/icons/16';
import { TiptapButton } from '../TiptapButton';
import { useEditorContext } from '../../editor_context';

export const CodeButton = props => {
   const { editor } = useEditorContext();

   return (
      <TiptapButton
         onClick={() => editor.chain().focus().toggleCode().run()}
         isActive={editor.isActive('code')}
         isDisabled={!editor.can().toggleCode()}
         icon={<Embed />}
         /* Translators: "Code" as in monospaced font */
         title={_js('Insert code')}
         shortcut={'e'}
      ></TiptapButton>
   );
};
